!function ($) {
    window.fp_scrollHorizontallyExtension = function () {
        var $this = this,
            fullpageData = window.fullpage_api.getFullpageData(),
            options = fullpageData.options,
            active = "active",
            activeSelector = "." + active,
            fpSection = "fp-section",
            fpSectionSelector = "." + fpSection,
            activeSectionSelector = fpSectionSelector + activeSelector,
            fpSlide = "fp-slide",
            slideSelector = "." + fpSlide,
            activeSlideSelector = slideSelector + activeSelector;

        $this.getScrollSection = function (direction, callback) {

            var activeSection = $(activeSectionSelector),
                currentSlide = activeSection.find(activeSlideSelector);
                slides = activeSection.find(slideSelector).length;

            if (!options.scrollHorizontally || slides <= 1) {
                return callback;
            }

            if (direction === "down") {
                if (currentSlide.index() + 1 != slides) {
                    return window.fullpage_api.moveSlideRight
                }
            } else if (currentSlide.index()) {
                return window.fullpage_api.moveSlideLeft;
            }

            return callback;
        }

        return $this;
    }
}(jQuery);